(function () {
  'use strict';

  document.documentElement.classList.add('js');

  /* ---------------------------------------------------------------
     Page-leaving fade.
     Only fires for clicks that genuinely navigate away. Previously
     any same-origin click triggered it, so "#" anchors, middle
     clicks, downloads and cancelled navigations left the page stuck
     at 75% opacity with no way back.
  --------------------------------------------------------------- */
  var leaveTimer = null;

  function clearLeaving() {
    if (leaveTimer) {
      clearTimeout(leaveTimer);
      leaveTimer = null;
    }
    document.body.classList.remove('page-leaving');
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    if (link.target && link.target !== '_self') return;
    if (link.hasAttribute('download')) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    if (url.origin !== window.location.origin) return;

    // Same page, hash only: no navigation happens, so never fade.
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

    document.body.classList.add('page-leaving');
    // Safety net: if navigation is blocked or cancelled, restore.
    leaveTimer = setTimeout(clearLeaving, 4000);
  });

  window.addEventListener('pageshow', clearLeaving);
  window.addEventListener('popstate', clearLeaving);

  /* ---------------------------------------------------------------
     Product variant switching.
     The select posts the variant id on its own (works without JS);
     this keeps the price, the button state and the ?variant= URL in
     sync when the shopper changes variant.
  --------------------------------------------------------------- */
  function initProductForm(root) {
    var select = root.querySelector('[data-variant-select]');
    var priceEl = root.querySelector('[data-product-price]');
    var button = root.querySelector('[data-add-button]');
    var dataEl = root.querySelector('[data-variant-data]');
    if (!select || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var addLabel = (button && button.getAttribute('data-add-label')) || 'Add to Cart';

    function update() {
      var id = parseInt(select.value, 10);
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) {
          variant = variants[i];
          break;
        }
      }
      if (!variant) return;

      if (priceEl) priceEl.textContent = variant.price;

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? addLabel : 'Sold Out';
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    select.addEventListener('change', update);
    update();
  }

  /* ---------------------------------------------------------------
     Product page image zoom. Click a gallery image to open it large;
     click the backdrop, the close button, or press Escape to close.
     Scoped to [data-product-root], so it never touches collection or
     home page grids.
  --------------------------------------------------------------- */
  function initLightbox(root) {
    var lightbox = root.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-image]');
    var closeButton = lightbox.querySelector('[data-lightbox-close]');
    var triggers = root.querySelectorAll('[data-zoom-trigger]');
    var lastFocused = null;

    function open(trigger) {
      var src = trigger.getAttribute('data-zoom-src');
      if (!src) return;
      img.src = src;
      img.alt = trigger.getAttribute('data-zoom-alt') || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lastFocused = document.activeElement;
      closeButton.focus();
    }

    function close() {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (event) {
        open(event.currentTarget);
      });
    }

    closeButton.addEventListener('click', close);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target === img) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* ---------------------------------------------------------------
     Cart: pressing Enter inside a quantity field used to submit the
     first button in the form (Checkout), sending the shopper to
     checkout with the old quantities. Route Enter to Update instead.
  --------------------------------------------------------------- */
  function initCartForm(form) {
    var updateButton = form.querySelector('[data-cart-update]');
    if (!updateButton) return;

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var target = event.target;
      if (!target || target.tagName !== 'INPUT') return;
      if (target.type !== 'number' && target.type !== 'text') return;
      event.preventDefault();
      updateButton.click();
    });
  }

  function init() {
    var productRoot = document.querySelector('[data-product-root]');
    if (productRoot) {
      initProductForm(productRoot);
      initLightbox(productRoot);
    }

    var cartForm = document.querySelector('.cart-form');
    if (cartForm) initCartForm(cartForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
